export default __webpack_public_path__ + "static/media/blog-arrow.4388b3de.svg";